var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-text"},[(_vm.teaser)?[_vm._v(" "+_vm._s(_vm.processedText)),_c('router-link',{staticClass:"more",attrs:{"to":`/event/${_vm.uid}`}},[_vm._v("mehr >>>")])]:[_c('div',{staticClass:"event-text-rt",domProps:{"innerHTML":_vm._s(_vm.processedText)}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }